/**
 * Colour scale shown inside the playback dock. Redraws from the data that
 * app.js's updateLegend() publishes on #colorScaleOverlay (which itself stays
 * hidden and only carries the `.visible` state). Categorical products
 * (Precip Type / HCA) get labelled swatches instead of a gradient.
 */

const SHORT = {
    reflectivity: "REF", velocity: "VEL", spectrum_width: "SW",
    correlation_coefficient: "CC", differential_reflectivity: "ZDR",
    l3_reflectivity: "REF", l3_velocity: "VEL", l3_echo_tops: "ET", l3_vil: "VIL",
    l3_hydrometeor: "HC", l3_hybrid_hca: "HHC", l3_zdr: "ZDR", l3_cc: "CC", l3_kdp: "KDP",
};

function esc(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
}

/** "5 dBZ" → ["5", "dBZ"]; "0.70" → ["0.70", ""]. */
function splitUnit(tick) {
    const m = String(tick).match(/^([+\-−±]?[\d.]+)\s*(.*)$/);
    return m ? [m[1], m[2]] : [String(tick), ""];
}

function render(el, detail) {
    if (!detail) return;
    const items = detail.items || [];
    const categorical = (detail.ticks || []).length === 0 && items.length > 0;
    // Config lists items and ticks high → low; draw low → high, left to right.
    const low = items.slice().reverse();
    let unit = "";
    const values = (detail.ticks || []).slice().reverse().map((t) => {
        const [v, u] = splitUnit(t);
        if (u) unit = u;
        return v;
    });
    const stops = low.map((it, i) => `${it.color} ${((i / Math.max(1, low.length - 1)) * 100).toFixed(1)}%`).join(", ");

    el.classList.toggle("is-categorical", categorical);
    el.style.setProperty("--grad-x", `linear-gradient(to right, ${stops})`);
    el.setAttribute("aria-label", `${detail.label} colour scale${unit ? `, ${unit}` : ""}`);

    el.innerHTML = `
        <div class="rr-legend-head">
            <span class="rr-legend-code">${esc(detail.code || SHORT[detail.product] || "")}</span>
            <span class="rr-legend-title">${esc(detail.label)}</span>
            <span class="rr-legend-unit">${esc(unit)}</span>
        </div>
        ${categorical ? `
        <div class="rr-legend-cats">
            ${items.map((it) => `<span class="rr-legend-cat"><i style="background:${it.color}"></i>${esc(it.label)}</span>`).join("")}
        </div>` : `
        <div class="rr-legend-scale">
            <div class="rr-legend-bar"></div>
            <div class="rr-legend-ticks">${values.map((v) => `<span>${esc(v)}</span>`).join("")}</div>
        </div>`}
    `;
}

export function installDockLegend() {
    const overlay = document.getElementById("colorScaleOverlay");
    const dock = document.querySelector(".map-animation-inner");
    if (!overlay || !dock) return;
    const el = document.createElement("div");
    el.className = "rr-legend";
    el.setAttribute("role", "img");
    dock.appendChild(el);
    overlay.addEventListener("legendchange", (e) => render(el, e.detail));
    render(el, overlay.legend);
}
